import React from 'react';
import { PhotoSwipeGallery } from 'react-photoswipe';

import withCeWrapper from 'src/hocs/withCeWrapper';

interface ItemType {
  /** Height of the images in pixels- */
  height: string;
  /** Image path. */
  src: string;
  /** Path to image thumbnail. */
  srcThumbnail?: string;
  /** Title to display the image with. */
  title: string;
  /** Width of the images in pixels- */
  width: string;
}

interface GalleryProps {
  /** List of configurations for each image to display. */
  items: ItemType[];
}

/**
 * Gallery
 *
 * @param {Object} props Component properties
 */
const Gallery = ({ items }: GalleryProps) => (
  <PhotoSwipeGallery
    items={items.map((item) => ({
      src: item.src,
      thumbnail: item.srcThumbnail || item.src,
      w: item.width,
      h: item.height,
      title: item.title,
    }))}
    // eslint-disable-next-line react/no-unstable-nested-components
    thumbnailContent={(item: { thumbnail: string; title: string }) => (
      <img src={item.thumbnail} alt={item.title} />
    )}
    // disable history so page does not jump to top on close
    options={{ history: false }}
  />
);

Gallery.defaultProps = {};

export default withCeWrapper()(Gallery);
